import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofz22V4 } from './pages-map'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4: Record<
  Exclude<PageIdWoofz22V4, PageIdWoofz22V4.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofz22V4.SEX_22V4]: {
    id: PageIdWoofz22V4.SEX_22V4,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4.DOG_AGE_22V4]: {
    id: PageIdWoofz22V4.DOG_AGE_22V4,
    progressBar: 'controlled',
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4.DOG_BREED_22V4]: {
    id: PageIdWoofz22V4.DOG_BREED_22V4,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4.DOG_BREED_ID_22V4]: {
    id: PageIdWoofz22V4.DOG_BREED_ID_22V4,
  },
  [PageIdWoofz22V4.URGE_22V4]: {
    id: PageIdWoofz22V4.URGE_22V4,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4.COMMANDS_61_22V4]: {
    id: PageIdWoofz22V4.COMMANDS_61_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4.COMMANDS_62_22V4]: {
    id: PageIdWoofz22V4.COMMANDS_62_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4.COMMANDS_63_22V4]: {
    id: PageIdWoofz22V4.COMMANDS_63_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4.URGE_2_22V4]: {
    id: PageIdWoofz22V4.URGE_2_22V4,
    theme: THEMES.URGE,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4.POTTY_22V4]: {
    id: PageIdWoofz22V4.POTTY_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4.BEHAVIOR_22V4]: {
    id: PageIdWoofz22V4.BEHAVIOR_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4.TRAINING_22V4]: {
    id: PageIdWoofz22V4.TRAINING_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofz22V4.PREPARE_FLOW_22V4]: {
    id: PageIdWoofz22V4.PREPARE_FLOW_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4.DOG_STATISTICS_22V4]: {
    id: PageIdWoofz22V4.DOG_STATISTICS_22V4,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofz22V4.EMAIL_22V4]: {
    id: PageIdWoofz22V4.EMAIL_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4.NEWSLETTER_URGE_22V4]: {
    id: PageIdWoofz22V4.NEWSLETTER_URGE_22V4,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofz22V4.LAST_CHANCE_OFFER_22V4]: {
    id: PageIdWoofz22V4.LAST_CHANCE_OFFER_22V4,
  },
  [PageIdWoofz22V4.WELCOME_TO_WOOFZ_22V4]: {
    id: PageIdWoofz22V4.WELCOME_TO_WOOFZ_22V4,
    hasHeader: true,
  },
  [PageIdWoofz22V4.SUBSCRIPTIONS_22V4]: {
    id: PageIdWoofz22V4.SUBSCRIPTIONS_22V4,
  },
  [PageIdWoofz22V4.CANCEL_OFFER_22V4]: {
    id: PageIdWoofz22V4.CANCEL_OFFER_22V4,
  },
  [PageIdWoofz22V4.CHAT_UPSELL_22V4]: {
    id: PageIdWoofz22V4.CHAT_UPSELL_22V4,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4.UPSELL_22V4]: {
    id: PageIdWoofz22V4.UPSELL_22V4,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4.UPSELL_FEEDING_GUIDE_22V4]: {
    id: PageIdWoofz22V4.UPSELL_FEEDING_GUIDE_22V4,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4.UPSELL_EMOTIONAL_SUPPORT_22V4]: {
    id: PageIdWoofz22V4.UPSELL_EMOTIONAL_SUPPORT_22V4,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4.ROVER_UPSELL_22V4]: {
    id: PageIdWoofz22V4.ROVER_UPSELL_22V4,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofz22V4.DOWNLOAD_22V4]: {
    id: PageIdWoofz22V4.DOWNLOAD_22V4,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
